import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAlertDialogData } from '@irb/app.model';
import { IrbAppEvents, IrbClientsEvents } from '@irb/irb-common/events';
import { IOrdersSupportDetails, IWorkflowDialogData } from '@irb/irb-orders/irb-orders.model';

import { InventoryComponent } from "@irb/irb-orders/order-blotter/inventory/inventory.component"
import {CalltoactionService} from '@irb-common/components/calltoaction/calltoaction.service';
@Injectable({
  providedIn: 'root',
})
export class InlineOrderStatusAction {
  nextAction: Function;
  isUiTest = false;
  constructor(private ctas: CalltoactionService) {
  }
  updateSingleOrderStatus(actionType:string, postData:any, params:any, parent:InventoryComponent){
    let itemsToProceed:any = [];
    itemsToProceed.push(postData);
    const recordsToPost = parent.orderStatusAction.getPostData(
        itemsToProceed,
        actionType);
      this.ctas.remove();
    this.updateOrderStatusInLineAction(recordsToPost[0], actionType, params, parent);
}

  inlineGridActionTypeCheckWarnings(actionType:string, item:any, params:any, parent:InventoryComponent) {
    const thisOrdType = item.orderType;
    const thisPrice = item.price;
    const isBlockOrder = item.isBlockOrder;
    const ordIsNotHeld = item.ordIsNotHeld;
    const notHeldDestination = item.notHeldDestination;
    const orderStatus = item.orderStatus;
    const isRollTrade = item.isRollTrade;
    this.ctas.remove();

    if ((actionType == "CANCEL" || actionType == "REPLACE") && notHeldDestination == "AOM_PRINTER" && (orderStatus == "SUBMITTED_TO_VEO" || orderStatus == "PARTIALLY_FILLED")) {
      parent.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'warn',
            closable:true,
            sticky:true,
            summary: 'Block desk',
            detail: "Please contact the Block Desk at " + parent.blockDeskContact + " to cancel or replace this order. Not Held Orders submitted to the Block Desk cannot be canceled or replaced through iRebal."
        });
    } else {

        if (actionType == "SUBMIT" && !isRollTrade && (thisOrdType == "LIMIT" || thisOrdType == "STOP") && (!thisPrice || thisPrice == "")) {
            if (thisOrdType == "STOP") {
              parent.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'warn',
                    closable:true,
                    sticky:true,
                    summary: 'Alert',
                    detail: "When you place a stop order, you must enter a stop price. Use a positive number with 0 to 2 decimal places."
                });
            } else if (thisOrdType == "LIMIT") {
              parent.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'warn',
                    closable:true,
                    sticky:true,
                    summary: 'Alert',
                    detail: "When you place a limit order, you must enter a limit price. Use a positive number with 0 to 2 decimal places."
                });
            }
        } else if (actionType == "SUBMIT") {
            parent.actionType = actionType;
            // EF IREBAL-1994 remove checkForSubmitWarnings
            //this.inlineGridActionCheckForSubmitWarnings([item],params, parent);
            this.updateSingleOrderStatus('SUBMIT', params.data, params, parent);
        } else if (actionType == "REPLACE") {
            if (isBlockOrder) {
              parent.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                    dTitle: 'Partially Filled Block Order',
                    dProceedBtnLabel: 'Continue',
                    dCancelBtnLabel:'Cancel',
                    msg: "If your replaced order is executed, iRebal will combine all executions into one average price and allocate underlying accounts with one trade, using this average.",
                    onProceed: () => {
                        
                      parent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params ,parent: parent, actionType: 'Replace',tradeInstructionsinit:true  });
                    }
                } as IAlertDialogData);
            } else {
              parent.as.fireEvent(IrbClientsEvents.SHOW_EDIT_TRADING_INSTRUCTIONS, { data: params,parent: parent, actionType: 'Replace',tradeInstructionsinit:true  });
          
            }
        } else {
          this.updateSingleOrderStatus(actionType, item, params, parent);
        }
    }
}
updateOrderStatusInLineAction(itemsToProceed:any, actionType:string, params:any, parent:InventoryComponent){
  parent.pfs.updateOrder(itemsToProceed).subscribe(
      (response: any) => {
        parent.closeDialog();
        if(response.responseStatus=="SUCCESS"){
          parent.getOrdersSupportDetails();
          setTimeout(() => {
            parent.getOrdersSupportDetails();
          }, 2000);
          if(actionType == "SUBMIT" && response.responseData.notHeldDestination == "AOM_PRINTER"){
            parent.blockDeskWarningMsg();
          }
          if(actionType === 'SingleEdit' && itemsToProceed.notHeldDestination === "AOM_PRINTER" && itemsToProceed.ordIsNotHeld){
            if(itemsToProceed && itemsToProceed.userContactNo){
              parent.updateContactNumbers({
                  contactNo:itemsToProceed.userContactNo
                });
            }
          }
          const detailMsg = this.orderActionSuccessMsg(actionType);
          parent.as.fireEvent(IrbAppEvents.SHOW_TOAST, { severity: 'success', summary: 'Status', detail: detailMsg });
          if(params &&  params.data && params.node){
                params.data.versionId = response.responseData.versionId;
                params.data.orderStatus = response.responseData.orderStatus;
                params.data['edited'] = true;
                params.data.orderStatus = response.responseData.orderStatus;
                params.data.accountNumber = response.responseData.accountNumber;
                params.data.orderID = response.responseData.orderID;
                params.data.accountName = response.responseData.accountName;
                params.data.portfolioId =  response.responseData.portfolioId;
                params.data.securitySymbol = response.responseData.securitySymbol;
                params.data.securityDescription = response.responseData.securityDescription;
                params.data.portfolioName = response.responseData.portfolioName;
                params.data.blockOrderId = response.responseData.blockOrderId;
                params.data.securityType = response.responseData.securityType;
                params.node.setData(params.data);
              
                setTimeout(() => {
                    params.data['edited'] = false;
                    params.node.setData(params.data);
                }, 5000);
              }else{
                parent.refreshGrid();
              }
        } else if (response.responseStatus == "STALEDATAEXCEPTION") {
          parent.refreshRequired();
        } else if(response.responseStatus=='EXCEPTION') {
          const message = response.responseUtilityMap?.Message || 'An error occurred while updating order.';
          parent.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Error occurred',
              detail: message
          });
          if (!this.isUiTest) {
              throw new Error('Order blotter. updateOrderStatusInLineAction - updateOrder failed. ');
          }
        }
      },
      () => {
        parent.closeDialog();
        parent.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      }
    );
  }
  inlineGridActionCheckForSubmitWarnings(items:any,params:any,parent:InventoryComponent){
    parent.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    const postData = parent.orderStatusAction.getSubmitWaringPostData({itemsToProceed:items,actionType:'SUBMIT'});
    parent.pfs.checkForSubmitWarnings(postData).subscribe(
      (response: any) => {
        if(response.responseStatus=="SUCCESS"){
          parent.as.fireEvent(IrbAppEvents.HIDE_WAIT);
           const wfdForSubmitWarning:IWorkflowDialogData = parent.orderStatusAction.getSubmitWarningMsg(response,parent.ordersSupportDetails);
           if(wfdForSubmitWarning && wfdForSubmitWarning.msgList && wfdForSubmitWarning.msgList.length){
            parent.workflowDialogData = wfdForSubmitWarning;
            parent.workflowDialogData.nextAction = () => {
                this.updateSingleOrderStatus('SUBMIT',params.data,params,parent);
            }
            parent.openWorkflowDialog();
           }else{
            this.updateSingleOrderStatus('SUBMIT',params.data,params,parent);
           }
        }
      },
      () => {
        parent.closeDialog();
        parent.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          if (!this.isUiTest) {
              throw new Error('Order blotter. inlineGridActionCheckForSubmitWarnings - checkForSubmitWarnings failed. ');
          }
      }
    );
  }
  exportAllocations(postData:any,parent:InventoryComponent){
      this.ctas.remove();
    let itemsToProceed:any = [];
    itemsToProceed.push(postData);
    parent.exportService.exportBlockAllocations(parent,parent.current,false,[], itemsToProceed);
}
orderActionSuccessMsg(actionName:string){
  switch (actionName) {
    case 'VALIDATE':
        return "The selected order(s) have been sent for validation.";
    case 'PLACE_TRADES_ON_HOLD':
        return "The selected order(s) have been placed on hold.";
    case 'MARK_AS_EXECUTED':
       return "The selected order(s) have been marked as executed.";
    case 'REVERT_TO_APPROVED':
       return "The selected order(s) have been reverted to approved.";
    case 'SUBMIT':
      return "The selected order(s) have been submitted. Refresh the blotter to view the Order IDs.";
    case 'CANCEL':
      return "The selected order(s) have been canceled.";
    case 'OVERRIDE':
       return "You have overridden the warning.";
    case 'MARK_AS_CANCELLED':
       return "The selected order(s) have been marked as canceled.";
    case 'MULTI_EDIT':
      return "";
    case "MANUALLY_SUBMIT":
      return "The selected order(s) have been marked manually submitted.";
    case "REPLACE":
        return "Your change has been saved.";
    case "MANAGE_ALLOCATION":
        return "Allocation file will be sent.";
    default:
        return "Your change has been saved." ;
  }
}

}
